window.theme = window.theme || {};

theme.brandPLP = (function() {
  function dynamicSort(property) {
    var sortOrder = 1;

    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }

    return function (a,b) {
      if(sortOrder == -1){
        return b[property].localeCompare(a[property]);
      }else{
        return a[property].localeCompare(b[property]);
      }
    }
  }

  function init() {
    var brandFragment = '';
    if (typeof atzBrands !== 'undefined' ) {
      atzBrands.sort(dynamicSort("name"));

      for (var key in atzBrands) {
        brandFragment+=''
          + '<li>'
          + '<a href="'+atzBrands[key].url+'">'+atzBrands[key].name+'</a>'
          + '</li>';
      }
      $('.brand-listing').html(brandFragment);
    }
  }
  return {
    init: init
  }
})();

theme.customerTemplates = (function() {

  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  return {
    init: function() {

      $('.cart-delivery-method').on('change', function(){
        if ( $(this).val() == 'locker' ) {
          $('.cart-locker-options').removeClass('hide');
        }
      });

      $('form.cart').attr('org-act', $('form.cart').attr('action'));


      resetPasswordSuccess();
    }
  };
})();



theme.init = function() {
  theme.customerTemplates.init();
  theme.brandPLP.init();
};

$(theme.init);
